<div class="zad-confirmation-dialog text-center">
    <h2 class="size-3 weight-bold">
        {{data.confirmTitle}}
    </h2>
    <div class="btns-container mt-4">
        <button class="z-btn text-light size-2 bg-secondary mlr-2 pointer" (click)="closeDialog(true)">
            {{data.confirmLabel}}
        </button>
        <button class="z-btn btn-outlined text-secondary size-2 mlr-2 pointer" (click)="closeDialog(false)">
            {{data.cancelLabel}}
        </button>
    </div>
</div>